import { useMutation, useQueryClient, MutationOptions } from "react-query";
import { del, API_URL, APIResponse, APIError } from "../api";

export function useRemoveFromCart(
  options?: MutationOptions<APIResponse<any>, APIError, string>
) {
  const queryClient = useQueryClient();

  const { mutate, isLoading, isError, error, data } = useMutation(
    (cartItemId: string) => {
      return del(`${API_URL}/commerce/cart/items/${cartItemId}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.refetchQueries("cart");
        options?.onSuccess?.(...args);
      },
    }
  );

  return {
    removeFromCart: mutate,
    removingFromCart: isLoading,
    isRemoveCartError: isError,
    removeCartError: error,
    removeCartResponse: data,
  };
}
